/*
 * Filename: CQSetValueRuleController.ts
 * Description: Controller for set value rule
 */

import { CQAppConstant } from '../../../app-constants';
import { ICriteria } from '../../../components/template-configuration/layout-configuration-panel/ILayoutConfigurationPanel.Interface';
import { FormRuleController } from '../form-rule.controller';
import { ISetValueRuleObject, ISetValuesRuleObject } from '../IRules.interface';

export class CQSetValueRuleController  extends FormRuleController {
    public ruleJSON: any = {};

    constructor(ruleObject: ISetValuesRuleObject, eventType?: string) {
        super();
        this.formRuleJson(ruleObject.setValues, eventType);
    }

    /**
     * @description Generates form JSON from rules
     * @function formRuleJson
     * @param { obj } setValueRuleData contains details related to setValues object
     * @param { boolean } shouldSkip determins should skip the checking of filtering process
     * @param { string } eventType
     * @returns { obj } JSON format of form rule
     * @memberof CQSetValueRuleController
     */
    private formRuleJson = (setValueRuleData:ISetValueRuleObject[] , eventType?: string) => {

        const setValueRule: ISetValueRuleObject[] = this.formRuleFilter(setValueRuleData);
        if (eventType) {
            this.ruleJSON = {
                [eventType]: { 'setValues': setValueRule }
            };
        } else {
            this.ruleJSON = {
                'setValues': setValueRule
            };
        }

        return this.formRuleJson;
    }

    /**
    * @memberof CQSetValueRuleController
    */
    public formRuleFilter = (setValueRuleData:ISetValueRuleObject[]) => {
        const setValues: any[] = [];
        setValueRuleData.forEach((setValueSection) => {
            const fields: string[] = [];
            let setValuesObject = { fields, filter: '', action: {} };
            setValueSection.addedCriterias.forEach((criteria: ICriteria) => {
                const fieldName = criteria.field.split('-')[0];
                if(!setValuesObject.fields.includes(fieldName)){
                    setValuesObject.fields.push(fieldName);
                }

                if (criteria.isDynamic
                    && criteria.operator !== CQAppConstant.EXISTS
                    && criteria.operator !== CQAppConstant.ISEMPTY) {
                    const fieldName = criteria.compareTo.split('-')[0];
                    if(!setValuesObject.fields.includes(fieldName)){
                        setValuesObject.fields.push(fieldName);
                    }
                }
            });
            
            if(setValueSection.shouldSkip){
                setValuesObject.filter = "true";
            }else{
                setValuesObject.filter = this.formFilterString(setValueSection.complexLogicQuery, setValueSection.addedCriterias);
            }

            setValueSection.actions.map((action: any) => {
                action.compareTo = this.covertActionValueStringIfIBooleanType(action.compareTo);
                return action;
            });
            const actionObj = setValueSection.actions.reduce(function (o: any, action: any) {
                const dynamicValueItem = CQAppConstant.SETVALUE_RULE_DYNAMIC_SOURCE_VALUES.filter(item => item.label === action.compareTo);
                const key = action.field;
                if (dynamicValueItem.length !== 0 && dynamicValueItem[0].isSupportedFunction) {
                    o[key] = action.compareTo === 'AddDays()'?{ 'fx': `${dynamicValueItem[0].value}`, 'value': parseInt(action.supportedFunctionValue) }:{ 'fx': `${dynamicValueItem[0].value}`};
                } else if (dynamicValueItem.length !== 0 && !dynamicValueItem[0].isSupportedFunction) {
                    o[key] = dynamicValueItem[0].value;
                }
                else {
                    let isNumber = false;
                    if (action.compareTo === true || action.compareTo === false || action.compareTo === '') {
                        isNumber = false;
                    } else {
                        isNumber = !isNaN(action.compareTo);
                    }
                    const value = isNumber ? parseInt(action.compareTo) : action.compareTo;
                    o[key] = value;
                }

                return o;
            }, {});
            setValuesObject.action = actionObj;
            setValues.push(setValuesObject);
        });

        return setValues;
    }
}

